import React, {useEffect, useState} from 'react';
import _ from "lodash";
import {searchPinterestAccountsWithSearchCriteria} from "../../services/pinterest-account-data.service";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";
import ShowEmptyListMessage from "../../../design/components/common/show-empty-list-message";
import {PINTEREST_ACCOUNT_FIELDS_LIST} from "../../constants/pinterest-account.constant";
import GoToLink from "../../../common/ui/go-to-link";
import ProductImageSmall from "../../../pod/components/product-upload/product-image-small";
import {syncPinterestAccount} from "../../services/pinterest-api-service";

const defaultFilterCriteria: any = {};

const PinterestAccountsList = () => {
    const [pinterestAccountsList, setPinterestAccountsList] = useState(null);
    const [filterCriteria, setFilterCriteria] = useState(defaultFilterCriteria);
    const [dataFetchInProgress, setDataFetchInProgress] = useState(true);

    const getPinterestAccountList = async () => {
        setDataFetchInProgress(true);

        const searchCriteriaList = [];

        _.forIn(filterCriteria, (value, attribute) => {
            if ((!_.isEmpty(value) || value === true) && value !== 'EMPTY') {
                searchCriteriaList.push({field: attribute, condition: '==', value: value});
            }
        });

        const pinterestAccountListResult = await searchPinterestAccountsWithSearchCriteria(searchCriteriaList);

        setPinterestAccountsList(pinterestAccountListResult);
        setDataFetchInProgress(false);
    }

    useEffect(() => {
        refreshPinterestAccountList();
    }, [filterCriteria]);

    const refreshPinterestAccountList = async () => {
        await getPinterestAccountList();
    }

    const startPinterestAccountSync = async (pinterestAccount) => {
        setDataFetchInProgress(true);
        await syncPinterestAccount(pinterestAccount?.id);

        await refreshPinterestAccountList();
        setDataFetchInProgress(false);
    }


    return (
        <>

            <div className="flex justify-between">

                <div className="flex justify-start items-center mt-2 -ml-2 mb-2 w-full">
                    <div className={'text-xl ml-2'}>
                        Pinterest Account
                    </div>

                    <div className="ml-4">
                        <ShowProgressSpinner dataFetchInProgress={dataFetchInProgress}/>
                    </div>
                </div>

                <div className="text-center w-1/6 flex items-center justify-end">
                </div>

            </div>

            <div className="flex justify-start">

                <div
                    className="w-full bg-white mt-4">

                    <ShowEmptyListMessage
                        dataList={pinterestAccountsList}
                        dataFetchInProgress={dataFetchInProgress}
                        label={'Pinterest Accounts'}/>

                    {pinterestAccountsList?.length > 0 &&
                        <table className="w-full">
                            <thead className="">
                            <tr>
                                <th className="p-2 border border-gray-400 bg-gray-400 text-white w-12">S.No</th>
                                {PINTEREST_ACCOUNT_FIELDS_LIST?.map((pinterestAccountField, rowIndex) => (
                                    <th key={`th-${rowIndex}`}
                                        className={`p-2 border border-gray-400 bg-gray-400 text-white text-left pl-2 ${pinterestAccountField?.cssClass}`}>{pinterestAccountField?.label}</th>
                                ))}
                                <th className="p-2 border border-gray-400 bg-gray-400 text-white">
                                    Actions
                                </th>
                            </tr>
                            </thead>
                            <tbody className="">
                            {pinterestAccountsList?.map((pinterestAccount, rowIndex) => (
                                <tr key={`row-${rowIndex}`} className="border border-gray-400">
                                    <td className="p-2 border border-gray-400 m-auto">
                                        <div className="flex justify-center w-12">
                                            {rowIndex + 1}
                                        </div>
                                    </td>

                                    {PINTEREST_ACCOUNT_FIELDS_LIST?.map((pinterestAccountField, columnIndex) => (
                                        <React.Fragment key={`column-${rowIndex}-${columnIndex}`}>
                                            <td className={`p-2 border border-gray-400 m-auto ${pinterestAccountField?.cssClass}`}>
                                                {pinterestAccountField?.optionsMap &&
                                                    <>{pinterestAccountField?.optionsMap[pinterestAccount?.account[pinterestAccountField?.attribute]]?.name}</>
                                                }

                                                {!pinterestAccountField?.optionsMap && !pinterestAccountField?.isImage &&
                                                    <>
                                                        {pinterestAccount?.account[pinterestAccountField?.attribute]}

                                                        {pinterestAccountField?.secondaryAttribute &&
                                                            <div className={'text-gray-500 text-sm'}>
                                                                {pinterestAccount?.account[pinterestAccountField?.secondaryAttribute]}
                                                            </div>
                                                        }

                                                        {pinterestAccountField?.secondaryAttributes &&
                                                            <>
                                                                {pinterestAccountField?.secondaryAttributes?.map((secondaryAttribute, secondaryIndex) => (
                                                                    <div key={`secondary-${secondaryIndex}`}
                                                                         className={'text-gray-500 text-sm'}>
                                                                        {pinterestAccount?.account[secondaryAttribute]}
                                                                    </div>
                                                                ))}
                                                            </>
                                                        }
                                                    </>
                                                }

                                                {pinterestAccountField?.isImage &&
                                                    <div className={`flex justify-center items-center`}>
                                                        <ProductImageSmall
                                                            imageUrl={pinterestAccount?.account[pinterestAccountField?.attribute]}/>
                                                    </div>
                                                }
                                            </td>
                                        </React.Fragment>
                                    ))}

                                    <td className="p-2 border border-gray-400 m-auto w-48">
                                        <div className="flex justify-center">
                                            <button
                                                className="button-green px-4 py-2 flex items-center justify-center"
                                                onClick={() => {
                                                    startPinterestAccountSync(pinterestAccount);
                                                }}>
                                                <span>Sync Pinterest</span>
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    }
                </div>

            </div>

        </>
    );
}

export default PinterestAccountsList
